var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5949 0.759645C20.5421 1.01318 21.2865 1.75751 21.54 2.70466C21.9982 4.41967 22 8.00001 22 8.00001C22 8.00001 22 11.5804 21.54 13.2954C21.2865 14.2425 20.5421 14.9869 19.5949 15.2403C17.88 15.7004 11 15.7004 11 15.7004C11 15.7004 4.12002 15.7004 2.405 15.2403C1.45785 14.9869 0.713533 14.2425 0.459993 13.2954C0 11.5804 0 8.00001 0 8.00001C0 8.00001 0 4.41967 0.459993 2.70466C0.713533 1.75751 1.45785 1.01318 2.405 0.759645C4.12002 0.299652 11 0.299652 11 0.299652C11 0.299652 17.88 0.299652 19.5949 0.759645ZM14.5134 8.00028L8.79785 11.2999V4.70063L14.5134 8.00028Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.39d146be9e96d7d8bac2e2559f684f26.svg";
export { ForwardRef as ReactComponent };